module.exports = __webpack_public_path__ + "img/forest-g44dfbde7d_1920.f8fd255e.jpeg";